export default {
    data() {
        return {
            generalLinks: false,
            socialLinks: false,
            footerLinks: false,
        };
    },
    methods: {
        prepareLinkData() {
            if (this.activeTree.links) {
                this.generalLinks = this.activeTree.links.data.filter(l => {
                    return l.type === 'link';
                });
                this.generalLinks.sort((a, b) => {
                    return a.position - b.position;
                });
                this.socialLinks = this.activeTree.links.data.filter(l => {
                    return l.type.includes('social-');
                });
                this.socialLinks.sort((a, b) => {
                    return a.position - b.position;
                });

                this.footerLinks = this.activeTree.links.data.filter(l => {
                    return l.type === 'footer';
                });
                this.footerLinks.sort((a, b) => {
                    return a.position - b.position;
                });
            }
        },
    },
};
